import { render, staticRenderFns } from "./GalleryFormats.vue?vue&type=template&id=175492fc&"
import script from "./GalleryFormats.vue?vue&type=script&lang=ts&"
export * from "./GalleryFormats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports